import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { flashMessage as flash } from "./../../../utils/flash/index";
import staffService from "./staffService";

// initialize state
const initialState = {
  staff_records: [],
  allStates: [],
  staff_list: [],
  isLoading: false,
  isSuccess: false,
  isError: false,
  isSelected: false,
  isUpdated: false,
  message: "",
  app_id: null,
  pages: {},
  staff_information: {},
  roles: [],
};

// fetch states
export const fetchAllStates = createAsyncThunk(
  "/staff/states",
  async (_, thunkAPI) => {
    try {
      return await staffService.fetchAllStates();
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
// fetch all staffs
export const getAllStaffs = createAsyncThunk(
  "/staff/staff-list",
  async (pageNumber, thunkAPI) => {
    try {
      return await staffService.getAllStaffs(pageNumber);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
// fetch all roles
export const getAllRoles = createAsyncThunk(
  "/staff/roles",
  async (_, thunkAPI) => {
    try {
      return await staffService.getAllRoles();
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
// fetch app status
export const getAppStatus = createAsyncThunk(
  "/staff/app-status",
  async (APP_ID, thunkAPI) => {
    try {
      return await staffService.getAppStatus(APP_ID);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
// fetch personal information
export const getStaffInformation = createAsyncThunk(
  "/staff/fetch/information",
  async (staff_id, thunkAPI) => {
    try {
      return await staffService.getStaffInformation(staff_id);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// add personal information
export const addStaffPersonalInfo = createAsyncThunk(
  "/staff/add/personal-info",
  async (personalInfo, thunkAPI) => {
    try {
      return await staffService.addStaffPersonalInfo(personalInfo);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
// add contact information
export const addStaffContactInfo = createAsyncThunk(
  "/staff/add/contact-info",
  async (contactInfo, thunkAPI) => {
    try {
      return await staffService.addStaffContactInfo(contactInfo);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
// add educational information
export const addStaffEducationalInfo = createAsyncThunk(
  "/staff/add/educational-info",
  async (educationalInfo, thunkAPI) => {
    try {
      return await staffService.addStaffEducationalInfo(educationalInfo);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
// delete educational information
export const removeStaffEducationalInfo = createAsyncThunk(
  "/staff/educational-info/id/delete",
  async (recordID, thunkAPI) => {
    try {
      return await staffService.removeStaffEducationalInfo(recordID);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
// add employment information
export const addStaffEmploymentInfo = createAsyncThunk(
  "/staff/add/employment-info",
  async (employmentInfo, thunkAPI) => {
    try {
      return await staffService.addStaffEmploymentInfo(employmentInfo);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
// add guarantor information
export const addStaffGuarantorInfo = createAsyncThunk(
  "/staff/add/guarantor-info",
  async (guarantorInfo, thunkAPI) => {
    try {
      return await staffService.addStaffGuarantorInfo(guarantorInfo);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
// add work experience
export const addStaffWorkExperience = createAsyncThunk(
  "/staff/add/work-experience",
  async (workExperience, thunkAPI) => {
    try {
      return await staffService.addStaffWorkExperience(workExperience);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
// add next of kin information
export const addStaffNextOfKinInfo = createAsyncThunk(
  "/staff/add/next-of-kin",
  async (nextOfKinInfo, thunkAPI) => {
    try {
      return await staffService.addStaffNextOfKinInfo(nextOfKinInfo);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// make staff user
export const makeStaffUser = createAsyncThunk(
  "/staff/make-user",
  async (data, thunkAPI) => {
    try {
      return await staffService.makeStaffUser(data);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// ===========================
// UPDATING STAFF INFORMATION
// ===========================

// Update Personal Info
export const updateStaffPersonalInfo = createAsyncThunk(
  "/staff/update/personal-info",
  async (personalInfo, thunkAPI) => {
    try {
      return await staffService.updateStaffPersonalInfo(personalInfo);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
// Update Contact Info
export const updateStaffContactInfo = createAsyncThunk(
  "/staff/update/contact-info",
  async (contactInfo, thunkAPI) => {
    try {
      return await staffService.updateStaffContactInfo(contactInfo);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
// Update Educational Info
export const updateStaffEducationalInfo = createAsyncThunk(
  "/staff/update/educational-info",
  async (educationalInfo, thunkAPI) => {
    try {
      return await staffService.updateStaffEducationalInfo(educationalInfo);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
// Update Employment Info
export const updateStaffEmploymentInfo = createAsyncThunk(
  "/staff/update/employment-info",
  async (employmentInfo, thunkAPI) => {
    try {
      return await staffService.updateStaffEmploymentInfo(employmentInfo);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
// Update Next of Kin Info
export const updateStaffNextOfKinInfo = createAsyncThunk(
  "/staff/update/next-of-kin-info",
  async (nextOfKinInfo, thunkAPI) => {
    try {
      return await staffService.updateStaffNextOfKinInfo(nextOfKinInfo);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
// Update Next of Kin Info
export const updateStaffPreviousWorkInfo = createAsyncThunk(
  "/staff/update/prev-work-info",
  async (previousWorkInfo, thunkAPI) => {
    try {
      return await staffService.updateStaffPreviousWorkInfo(previousWorkInfo);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
// Update Guarantor Info
export const updateStaffGuarantorInfo = createAsyncThunk(
  "/staff/update/guarantor-info",
  async (guarantorInfo, thunkAPI) => {
    try {
      return await staffService.updateStaffGuarantorInfo(guarantorInfo);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const deactivateStaff = createAsyncThunk(
  "/staff/update/DeactivateStaff",
  async (data, thunkAPI) => {
    try {
      return await staffService.deactivateStaff(data);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const activateStaff = createAsyncThunk(
  "/staff/update/activateStaff",
  async (data, thunkAPI) => {
    try {
      return await staffService.activateStaff(data);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// actions
const staffSlice = createSlice({
  name: "staff",
  initialState,
  reducers: {
    resetStaffRecords: (state) => initialState,
    resetStaffRecordBySlug: (state, action) => {
      state.staff_records[action] = {};
    },
    resetStaffStatus: (state) => {
      state.isError = false;
      state.isSuccess = false;
      state.isLoading = false;
      state.isUpdated = false;
      state.message = "";
    },
    resetStaffInformation: (state) => {
      state.staff_information = {};
    },
    setAppId: (state, action) => {
      state.app_id = action.payload;
      resetStaffStatus();
    },
    resetAppId: (state, action) => {
      state.app_id = null;
      resetStaffStatus();
    },
  },
  extraReducers: (builder) => {
    builder
      // fetching states and LGA
      .addCase(fetchAllStates.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchAllStates.fulfilled, (state, action) => {
        state.isLoading = false;
        state.allStates = action.payload.data;
      })
      .addCase(fetchAllStates.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
        flash("error", action.payload);
      })
      // fetching roles
      .addCase(getAllRoles.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAllRoles.fulfilled, (state, action) => {
        state.isLoading = false;
        state.roles = action.payload;
      })
      .addCase(getAllRoles.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
        // flash("error", action.payload);
      })
      // fetching App Status
      .addCase(getAppStatus.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAppStatus.fulfilled, (state, action) => {
        state.isLoading = false;
        const { previous_page, next_page } = action.payload.data;
        let pages = {
          previousPage: previous_page,
          nextPage: next_page,
        };
        state.pages = pages;
      })
      .addCase(getAppStatus.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
        flash("error", action.payload);
      })
      // adding staff personal info
      .addCase(addStaffPersonalInfo.pending, (state) => {
        flash("loading", "Creating...");
        state.isLoading = true;
      })
      .addCase(addStaffPersonalInfo.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload.data) {
          state.isError = false;
          state.isSuccess = true;
          flash("success", "Record created successfully");
          let newRecord = {
            personal_info: action.payload.data,
          };
          state.staff_records.push(newRecord);
          state.app_id = newRecord.personal_info.id;
        } else if (action.payload.error) {
          state.isLoading = false;
          state.isError = true;
          state.message = action.payload.error;
          flash("error", action.payload.error);
        } else if (action.payload.errors.image) {
          state.isError = true;
          state.message = action.payload.errors.image[0];
          flash("error", action.payload.errors.image[0]);
        }
      })
      .addCase(addStaffPersonalInfo.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
        flash("error", action.payload);
      })
      // adding staff contact info
      .addCase(addStaffContactInfo.pending, (state) => {
        flash("loading", "Creating...");
        state.isLoading = true;
      })
      .addCase(addStaffContactInfo.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload.data) {
          state.isError = false;
          state.isSuccess = true;
          flash("success", "Record created successfully");
          let newRecord = {
            contact_info: action.payload.data,
          };
          state.staff_records.push(newRecord);
          // state.app_id = newRecord.personal_info.id
        } else if (action.payload.error) {
          state.isError = true;
          state.message = action.payload.error;
          flash("error", action.payload.error);
        } else if (action.payload.errors) {
          if (typeof action.payload.errors === "string") {
            flash("error", action.payload.errors);
          }
          let phone_number = action.payload.errors.phone_no[0];
          state.isLoading = false;
          state.isError = true;
          if (phone_number) {
            flash("error", phone_number);
          } else {
            state.message = "an error occured";
            flash("error", "an error occured");
          }
        }
      })
      .addCase(addStaffContactInfo.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
        flash("error", action.payload);
      })
      // adding staff educational info
      .addCase(addStaffEducationalInfo.pending, (state) => {
        flash("loading", "Creating...");
        state.isLoading = true;
      })
      .addCase(addStaffEducationalInfo.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload.data) {
          state.isError = false;
          state.isSuccess = true;
          flash("success", "Record created successfully");
          let newRecord = action.payload.data;
          // check if record exist
          let educational_info = state.staff_records.some(
            (f) => f.educational_info
          );
          if (educational_info) {
            let record = state.staff_records.find((f) => f.educational_info);
            record.educational_info.push(newRecord);
          } else {
            // create new record
            newRecord = {
              educational_info: [action.payload.data],
            };
            state.staff_records.push(newRecord);
          }
          // state.staff_records['educational_info'].push(newRecord)
        } else if (action.payload.error) {
          state.isError = true;
          state.message = action.payload.error;
          flash("error", action.payload.error);
        } else if (action.payload.errors) {
          let errors = action.payload.errors;
          state.isLoading = false;
          state.isError = true;
          if (Object.keys(errors).includes("institution_name")) {
            let error = action?.payload?.errors?.institution_name[0];
            flash("error", error);
          } else if (Object.keys(errors).includes("document")) {
            let error = action.payload.errors.document[0];
            flash("error", error);
          } else {
            state.message = "an error occured";
            flash("error", "an error occured");
          }
        }
      })
      .addCase(addStaffEducationalInfo.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
        flash("error", action.payload);
      })
      // delete staff educational record
      .addCase(removeStaffEducationalInfo.pending, (state) => {
        flash("loading", "Creating...");
        state.isLoading = true;
      })
      .addCase(removeStaffEducationalInfo.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload.data) {
          state.isError = false;
          state.isSuccess = true;
          flash("success", "Record deleted successfully");
          let recordID = action.payload.data;
          recordID = parseInt(recordID);
          setTimeout(() => {
            window.location.reload();
          }, 1000);
          // check if record exist
          let educational_info = state.staff_records.some(
            (f) => f.educational_info
          );
          if (educational_info) {
            let record = state.staff_records.find((f) => f.educational_info);
            let result = record.educational_info.filter(
              (f) => f.id !== recordID
            );
            state.staff_records.map((d) => {
              if (d.educational_info) {
                return (d.educational_info = result);
              }
              return d;
            });
          }
        } else if (action.payload.error) {
          state.isError = true;
          state.message = action.payload.error;
          flash("error", action.payload.error);
        } else if (action.payload.errors) {
          let error = action.payload.errors.document[0];
          state.isLoading = false;
          state.isError = true;
          state.message = "an error occured";
          flash("error", error);
        }
      })
      .addCase(removeStaffEducationalInfo.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
        flash("error", action.payload);
      })
      // adding staff employment info
      .addCase(addStaffEmploymentInfo.pending, (state) => {
        flash("loading", "Creating...");
        state.isLoading = true;
      })
      .addCase(addStaffEmploymentInfo.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload.data) {
          state.isError = false;
          state.isSuccess = true;
          flash("success", "Record created successfully");
          let newRecord = {
            employment_info: action.payload.data,
          };
          state.staff_records.push(newRecord);
        } else if (action.payload.error) {
          state.isError = true;
          state.message = action.payload.error;
          flash("error", action.payload.error);
        } else if (action.payload.errors) {
          if (action.payload.errors.staff_id) {
            let message = action.payload.errors.staff_id[0];
            state.isLoading = false;
            state.isError = true;
            state.message = message;
            flash("error", message);
          } else {
            state.isLoading = false;
            state.isError = true;
            state.message = "an error occured";
            flash("error", "an error occured");
          }
        }
      })
      .addCase(addStaffEmploymentInfo.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
        flash("error", action.payload);
      })
      // adding staff guarantor info
      .addCase(addStaffGuarantorInfo.pending, (state) => {
        flash("loading", "Creating...");
        state.isLoading = true;
      })
      .addCase(addStaffGuarantorInfo.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload.data) {
          state.isError = false;
          state.isSuccess = true;
          flash("success", "Record created successfully");
          let newRecord = {
            guarantor_info: action.payload.data,
          };
          state.staff_records.push(newRecord);
        } else if (action.payload.error) {
          state.isLoading = false;
          state.isError = true;
          state.message = action.payload.error;
          flash("error", action.payload.error);
        } else if (action.payload.errors.image) {
          state.isError = true;
          state.message = action.payload.errors.image[0];
          flash("error", action.payload.errors.image[0]);
        } else if (action.payload.errors.phone_number) {
          state.isError = true;
          state.message = action.payload.errors.phone_number[0];
          flash("error", action.payload.errors.phone_number[0]);
        }
      })
      .addCase(addStaffGuarantorInfo.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
        flash("error", action.payload);
      })
      // adding staff work experience
      .addCase(addStaffWorkExperience.pending, (state) => {
        flash("loading", "Creating...");
        state.isLoading = true;
      })
      .addCase(addStaffWorkExperience.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload.data) {
          state.isError = false;
          state.isSuccess = true;
          flash("success", "Record created successfully");
          let newRecord = {
            work_experience: action.payload.data,
          };
          state.staff_records.push(newRecord);
        } else if (action.payload.error) {
          state.isLoading = false;
          state.isError = true;
          state.message = action.payload.error;
          flash("error", action.payload.error);
        } else if (action.payload.errors) {
          state.isError = true;
          flash("error", action.payload);
        }
      })
      .addCase(addStaffWorkExperience.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
        flash("error", action.payload);
      })
      // adding staff next of kin information
      .addCase(addStaffNextOfKinInfo.pending, (state) => {
        flash("loading", "Creating...");
        state.isLoading = true;
      })
      .addCase(addStaffNextOfKinInfo.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload.data) {
          state.isError = false;
          state.isSuccess = true;
          flash("success", "Record created successfully");
          let newRecord = {
            next_of_kin: action.payload.data,
          };
          state.staff_records.push(newRecord);
          state.pages = {};
          state.app_id = null;
        } else if (action.payload.error) {
          state.isLoading = false;
          state.isError = true;
          state.message = action.payload.error;
          flash("error", action.payload.error);
        } else if (action.payload.errors) {
          let phone_number = action.payload.errors.phone_number[0];
          state.isLoading = false;
          state.isError = true;
          if (phone_number) {
            flash("error", phone_number);
          } else {
            state.message = "an error occured";
            flash("error", "an error occured");
          }
        }
      })
      .addCase(addStaffNextOfKinInfo.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
        flash("error", action.payload);
      })
      // fetching all staffs
      .addCase(getAllStaffs.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAllStaffs.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;

        if (action.payload.data) {
          state.staff_list = action.payload;
        }
      })
      .addCase(getAllStaffs.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      // fetching staff information
      .addCase(getStaffInformation.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getStaffInformation.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.staff_information = action.payload.data;
      })
      .addCase(getStaffInformation.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
        flash("error", action.payload);
      })

      // make staff user
      .addCase(makeStaffUser.pending, (state) => {
        state.isLoading = true;
        flash("loading", "Loading...");
      })
      .addCase(makeStaffUser.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload.errors) {
          flash("error", action.payload.errors);
        } else {
          state.isUpdated = true;
          flash("success", "User created successfully");
        }
        // setTimeout(() => {
        //     window.location.reload()
        // }, 2000);
        // state.staff_information = action.payload.data;
      })
      .addCase(makeStaffUser.rejected, (state, action) => {
        state.isLoading = false;
        // state.isError = true;
        // state.message = action.payload;
        flash("error", action.payload);
      })

      // UPDATING STAFF INFORMATION
      // update personal information
      .addCase(updateStaffPersonalInfo.pending, (state) => {
        state.isLoading = true;
        flash("loading", "Updating...");
      })
      .addCase(updateStaffPersonalInfo.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isUpdated = true;
        // if (action.payload.data) {
        // state.staff_information = action.payload.data
        // window.location.reload();
        flash("success", "Record Updated Successfully");
        // }
        if (action.payload.error) {
          state.message = action.payload.error;
          flash("error", action.payload.error);
        }
      })
      .addCase(updateStaffPersonalInfo.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
        flash("error", action.payload);
      })
      // update contact information
      .addCase(updateStaffContactInfo.pending, (state) => {
        state.isLoading = true;
        flash("loading", "Updating...");
      })
      .addCase(updateStaffContactInfo.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload.data) {
          state.staff_information = action.payload;
          state.isUpdated = true;
          flash("success", "Record Updated Successfully");
        }
        if (action.payload.errors) {
          if (action.payload.errors.phone_no) {
            let message = action.payload.errors.phone_no[0];
            state.message = action.payload.errors.phone_no[0];
            flash("error", message);
          } else if (action.payload.errors) {
            let message = action.payload.errors;
            state.message = message;
            flash("error", message);
          }
        }
      })
      .addCase(updateStaffContactInfo.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
        flash("error", action.payload);
      })
      // updating staff educational info
      .addCase(updateStaffEducationalInfo.pending, (state) => {
        flash("loading", "Updating...");
        state.isLoading = true;
      })
      .addCase(updateStaffEducationalInfo.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload.data) {
          state.isError = false;
          state.isSuccess = true;
          state.isUpdated = true;
          flash("success", "Record updated successfully");
          // setTimeout(() => {
          //   window.location.reload();
          // }, 1000);
        } else if (action.payload.error) {
          state.isError = true;
          state.message = action.payload.error;
          flash("error", action.payload.error);
        } else if (action.payload.errors) {
          let error = action.payload.errors.document[0];
          state.isLoading = false;
          state.isError = true;
          state.message = "an error occured";
          flash("error", error);
        }
      })
      .addCase(updateStaffEducationalInfo.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
        flash("error", action.payload);
      })
      // updating staff educational info
      .addCase(updateStaffEmploymentInfo.pending, (state) => {
        flash("loading", "Updating...");
        state.isLoading = true;
      })
      .addCase(updateStaffEmploymentInfo.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload.data) {
          state.isError = false;
          state.isSuccess = true;
          state.isUpdated = true;
          flash("success", "Record updated successfully");
          // setTimeout(() => {
          //   window.location.reload();
          // }, 1000);
        } else if (action.payload.error) {
          state.isError = true;
          state.message = action.payload.error;
          flash("error", action.payload.error);
        } else if (action.payload.errors) {
          let error = "an error occured";
          state.isLoading = false;
          state.isError = true;
          state.message = "an error occured";
          flash("error", error);
        }
      })
      .addCase(updateStaffEmploymentInfo.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
        flash("error", action.payload);
      })
      // updating staff next of kin info
      .addCase(updateStaffNextOfKinInfo.pending, (state) => {
        flash("loading", "Updating...");
        state.isLoading = true;
      })
      .addCase(updateStaffNextOfKinInfo.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload.data) {
          state.isError = false;
          state.isSuccess = true;
          state.isUpdated = true;
          flash("success", "Record updated successfully");
          // setTimeout(() => {
          //   window.location.reload();
          // }, 1000);
        } else if (action.payload.error) {
          state.isError = true;
          state.message = action.payload.error;
          flash("error", action.payload.error);
        } else if (action.payload.errors) {
          let error = "an error occured";
          state.isLoading = false;
          state.isError = true;
          // state.message = "an error occured";
          flash("error", action.payload.errors.phone_number[0]);
          // flash("error", error);
        }
      })
      .addCase(updateStaffNextOfKinInfo.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
        flash("error", action.payload);
      })
      // updating staff next of kin info
      .addCase(updateStaffPreviousWorkInfo.pending, (state) => {
        flash("loading", "Updating...");
        state.isLoading = true;
      })
      .addCase(updateStaffPreviousWorkInfo.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload.data) {
          state.isError = false;
          state.isSuccess = true;
          flash("success", "Record updated successfully");
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        } else if (action.payload.error) {
          state.isError = true;
          state.message = action.payload.error;
          flash("error", action.payload.error);
        } else if (action.payload.errors) {
          let error = "an error occured";
          state.isLoading = false;
          state.isError = true;
          state.message = "an error occured";
          flash("error", error);
        }
      })
      .addCase(updateStaffPreviousWorkInfo.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
        flash("error", action.payload);
      })
      // updating staff guarantor info
      .addCase(updateStaffGuarantorInfo.pending, (state) => {
        flash("loading", "Updating...");
        state.isLoading = true;
      })
      .addCase(updateStaffGuarantorInfo.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload.data) {
          state.isError = false;
          state.isSuccess = true;
          flash("success", "Record updated successfully");
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        } else if (action.payload.error) {
          state.isError = true;
          state.message = action.payload.error;
          flash("error", action.payload.error);
        } else if (action.payload.errors) {
          let error = "an error occured";
          state.isLoading = false;
          state.isError = true;
          // state.message = "an error occured";
          flash("error", action.payload.errors.phone_number[0]);
        }
      })
      .addCase(updateStaffGuarantorInfo.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
        flash("error", action.payload);
      })
      // updating staff guarantor info
      .addCase(activateStaff.pending, (state) => {
        flash("loading", "Re-activating staff...");
        state.isLoading = true;
      })
      .addCase(activateStaff.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload) {
          state.isError = false;
          state.isSuccess = true;
          state.isUpdated = true;
          flash("success", "Staff activated successfully");
        } else if (action.payload.error) {
          state.isError = true;
          state.message = action.payload.error;
          flash("error", action.payload.error);
        } else if (action.payload.errors) {
          let error = "an error occured";
          state.isLoading = false;
          state.isError = true;
          flash("error", error);
        }
      })
      .addCase(activateStaff.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
        flash("error", action.payload);
      })
      .addCase(deactivateStaff.pending, (state) => {
        flash("loading", "Deactivating staff...");
        state.isLoading = true;
      })
      .addCase(deactivateStaff.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload) {
          state.isError = false;
          state.isSuccess = true;
          state.isUpdated = true;
          flash("success", "Staff deactivated successfully");
        } else if (action.payload.error) {
          state.isError = true;
          state.message = action.payload.error;
          flash("error", action.payload.error);
        } else if (action.payload.errors) {
          let error = "an error occured";
          state.isLoading = false;
          state.isError = true;
          flash("error", error);
        }
      })
      .addCase(deactivateStaff.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
        flash("error", action.payload);
      });
  },
});

export const {
  resetStaffStatus,
  resetStaffRecords,
  resetStaffRecordBySlug,
  resetStaffInformation,
  setAppId,
  resetAppId,
} = staffSlice.actions;

export default staffSlice.reducer;
